export const en: Record<string, string> = {
  // Nav
  "nav.home": "Home",
  "nav.play": "Play",
  "nav.lists": "Playlists",
  "nav.praktis": "Playlists",
  "nav.achievements": "Achievements",
  "nav.profile": "Profile",
  "nav.more": "More",
  "nav.challenge": "Challenge",
  "nav.h2h": "H2H",
  "nav.party": "Party",
  "nav.uncover": "Uncover",
  "nav.board": "Board",
  "nav.jukebox": "The Mix",

  // Home
  "home.greeting": "Welcome",
  "home.subgreeting": "What are we playing today?",
  "home.menu": "Menu",
  "home.stats.streak": "Streak",
  "home.stats.streak.days": "{n} days in a row",
  "home.stats.points": "Points",
  "home.recommended": "Today's Pick",
  "home.daily.label": "Daily Challenge",
  "home.daily.title": "Today's Niggun",
  "home.daily.subtitle": "One niggun, up to 6 notes.",
  "home.daily.cta": "Play now",
  "home.daily.pill.new": "New today",
  "home.daily.footer": "+80 pts on a perfect score",
  "home.praktis.label": "Free play · No limits",
  "home.praktis.title": "Praktis Shpiel",
  "home.praktis.subtitle": "Pick a playlist — alone or with friends.",
  "home.praktis.cta": "Browse playlists →",
  "home.praktis.footer": "Any time",
  "home.continue.title": "Continue Playing",

  // Praktis
  "praktis.title": "Praktis Shpiel",
  "praktis.subtitle": "Pick a playlist. Unlimited attempts.",

  // Profile / share
  "common.profile": "Profile",
  "profile.shareText": "Come play Niggunim!",

  // Uncover
  "uncover.tapToPlay": "Tap to start",
  "uncover.clue.plus": "Clue",
  "uncover.clue.decade": "Decade",
  "uncover.clue.genre": "Genre",
  "uncover.clue.wordCount": "Song Name",
  "uncover.clue.wordCountValue": "{n} words",
  "uncover.clue.artist": "Artist",
  "uncover.clue.extraNote": "Extra Note",
  "uncover.knewItQuestion": "Did you know this song?",
  "uncover.knewItYes": "Yes, I knew it",
  "uncover.knewItNo": "No, first time",
  "uncover.nailedIt": "Nailed it!",
  "uncover.knewItLabel": "You knew it",
  "uncover.missed": "Uncovered",
  "uncover.afterClues": "Guessed after {n} clue(s)",
  "uncover.noPointsHint": "No points — but now you know it",
  "uncover.weekly.title": "Weekly Uncover",
  "uncover.weekly.startCta": "Start Weekly Challenge",
  "uncover.weekly.continueCta": "Continue to next song",
  "uncover.weekly.completed": "✓ You've completed all songs this week",

  // Common
  "common.signIn": "Sign in",
  "common.signOut": "Sign Out",
  "common.cancel": "Cancel",
  "common.join": "Join",
  "common.back": "← Back",
  "common.loading": "Loading...",
  "common.or": "or join",
  "common.enterCode": "Enter code...",
  "common.discover": "Discover",
  "common.clue": "+ Clue",
  "common.nextSong": "Next Song →",
  "common.tryAgain": "Try Again",
  "common.end": "End",
  "common.songs": "Songs",
  "common.score": "Score",
  "common.streak": "Streak",
  "common.pts": "pts",
  "common.played": "played",

  // Cookie
  "cookie.message": "We use analytics cookies to improve the experience.",
  "cookie.accept": "Accept",
  "cookie.decline": "Decline",

  // Offline / Update / Error
  "offline.message": "You're offline — Daily Challenge is still available",
  "update.available": "New version available",
  "update.refresh": "Refresh",
  "error.title": "Something went wrong",
  "error.reload": "Reload",

  // App
  "app.silentMode": "Turn off silent mode for audio",
  "app.copyright": "© 2024–2026 Niggunim. All rights reserved.",

  // Guess
  "guess.placeholder": "Type a song or artist name...",

  // Share
  "share.whatsapp": "SHARE ON WHATSAPP",
  "share.result": "SHARE RESULT",
  "share.copied": "COPIED!",
  "share.invite": "INVITE FRIENDS",
  "share.inviteText": "Think you know niggunim? Try Niggunim — guess the tune one note at a time!\nhttps://niggunim.net",

  // Daily Challenge
  "daily.title": "Daily Challenge #{num}",
  "daily.tapToPlay": "Tap to play",
  "daily.nextChallenge": "Next Challenge In",
  "daily.hrs": "Hrs",
  "daily.min": "Min",
  "daily.sec": "Sec",
  "daily.gotIt": "Got it at ♪{stage}!",
  "daily.betterLuck": "Better luck tomorrow",
  "daily.incredible": "Incredible!",
  "daily.brilliant": "Brilliant!",
  "daily.nice": "Nice!",
  "daily.youGotIt": "You got it in {stage}!",
  "daily.attempt": "Attempt",
  "daily.points": "Points",
  "daily.tryTomorrow": "Try Again Tomorrow",
  "daily.songUnavailable": "Song unavailable, loading next...",
  "daily.viewLeaderboard": "View Leaderboard",
  "daily.thisWeek": "This Week",
  "daily.startWeekly": "Start Weekly Challenge",
  "daily.continuePlaying": "Continue Playing",
  "daily.loadingWeekly": "Loading weekly challenge...",
  "daily.daily": "Daily",
  "daily.weekly": "Weekly",

  // H2H
  "h2h.title": "Head-to-Head",
  "h2h.subtitle": "Challenge a friend to see who knows music better",
  "h2h.signIn": "Sign in to play H2H",
  "h2h.signInCreate": "Sign in to create challenges",
  "h2h.challengeFriend": "Challenge a Friend",
  "h2h.songs": "Songs",
  "h2h.quickDuel": "Quick duel",
  "h2h.bestOf3": "Best of 3",
  "h2h.fullBattle": "Full battle",
  "h2h.song": "{n} Song",
  "h2h.songPlural": "{n} Songs",
  "h2h.playlist": "Playlist",
  "h2h.randomAll": "Random (all songs)",
  "h2h.creating": "Creating...",
  "h2h.createChallenge": "Create Challenge",
  "h2h.challengeNotFound": "Challenge not found or already played.",
  "h2h.createFailed": "Failed to create challenge. Try again.",
  "h2h.invalidCode": "Invalid code or challenge expired.",
  "h2h.recentDuels": "Recent Duels",
  "h2h.whatsapp": "WhatsApp",
  "h2h.youCreated": "You created",
  "h2h.youJoined": "You joined",
  "h2h.waiting": "Waiting for Opponent",
  "h2h.shareLink": "Share this link",
  "h2h.sendWhatsApp": "Send via WhatsApp",
  "h2h.waitingJoin": "Waiting for someone to join...",
  "h2h.opponentJoined": "Opponent joined — starting...",
  "h2h.copyLink": "Copy link",
  "h2h.linkCopied": "Copied ✓",
  "h2h.viewResult": "View result",
  "h2h.deleteChallenge": "Delete challenge",
  "h2h.stillPlaying": "still playing",
  "h2h.opponentFinishedTitle": "Opponent finished!",
  "h2h.opponentFinishedBody": "Your opponent just finished — {score} pts. Can you beat it?",
  "h2h.startNow": "Start playing now (opponent can join later)",
  "h2h.joinChallenge": "Join a challenge",
  "h2h.duel": "H2H Duel",
  "h2h.songProgress": "Song {current} / {total}",
  "h2h.scoresIn": "Your scores are in!",
  "h2h.youWon": "You Won!",
  "h2h.tie": "It's a Tie!",
  "h2h.youLost": "You Lost!",
  "h2h.you": "You",
  "h2h.opponent": "Opponent",
  "h2h.opponentPending": "Share the code {code} — your opponent hasn't played yet.",
  "h2h.backToH2H": "Back to H2H",
  "h2h.challengeText": "{url}\nI challenge you to Niggunim! Can you guess the niggunim?",

  // Party
  "party.title": "Party Mode",
  "party.subtitle": "Play with Friends",
  "party.description": "Play with friends in the same room",
  "party.tagline": "One DJ, everyone buzzes in. Like Hitster, but free.",
  "party.signIn": "Sign in to play",
  "party.gameType": "Game Type",
  "party.buzzer": "Buzzer",
  "party.turns": "Turns",
  "party.buzzerDesc": "First to buzz wins the point",
  "party.turnsDesc": "Each player takes a turn guessing",
  "party.createRoom": "Create Room",
  "party.inviteWhatsApp": "Invite via WhatsApp",
  "party.players": "Players ({count})",
  "party.dj": "DJ",
  "party.waitingPlayers": "Waiting for players...",
  "party.startGame": "Start Game",
  "party.startSolo": "Start Solo",
  "party.songCount": "Party • Song {count}",
  "party.endGame": "End Game",
  "party.gameOver": "Game Over",
  "party.finalScores": "Final Scores",
  "party.songsPlayed": "{count} songs played",
  "party.newGame": "New Game",
  "party.inviteText": "Join my Niggunim party!\nRoom code: {code}\n{url}",
  "party.copyLink": "Copy link",
  "party.linkCopied": "Copied ✓",
  "party.room": "Room {code}",
  "party.modeLabel": "Party Mode · {mode}",

  // Leaderboard
  "board.title": "Leaderboard",
  "board.period": "Period",
  "board.topPlayers": "Top Players",
  "board.thisWeek": "This Week",
  "board.allTime": "All Time",
  "board.noScores": "No scores yet this week.",
  "board.playDaily": "Play the daily challenge to appear here!",
  "board.games": "{count} games",
  "board.bestStage": "Best ♪{stage}",

  // Jukebox
  "jukebox.endless": "∞ Endless Mode",
  "jukebox.endlessDesc": "Random songs, no limit. How far can you go?",
  "jukebox.allTime": "All-Time Essentials",
  "jukebox.easy": "Easy",
  "jukebox.medium": "Medium",
  "jukebox.allSongs": "All Songs",
  "jukebox.easyDesc": "The biggest hits everyone knows",
  "jukebox.mediumDesc": "Well-known songs across all eras",
  "jukebox.allDesc": "Full catalog - experts only",
  "jukebox.beginner": "Beginner Friendly",
  "jukebox.someClassics": "Some Classics",
  "jukebox.challengeMode": "Challenge Mode",
  "jukebox.playlists": "Playlists",
  "jukebox.loadError": "Failed to load playlists. Check your connection.",
  "jukebox.backToPlaylists": "← Back to Playlists",
  "jukebox.correct": "Correct",
  "jukebox.seeResults": "See Results",
  "jukebox.complete": "Playlist Complete!",
  "jukebox.accuracy": "{percent}% Accuracy",
  "jukebox.songUnavailable": "Song Unavailable",
  "jukebox.songUnavailableDesc": "Could not load the next song. This can happen due to temporary network issues.",

  // Profile
  "profile.title": "Your Profile",
  "profile.signInDesc": "Sign in to track your stats and compete",
  "profile.signInGoogle": "Sign in with Google",
  "profile.lifetimeScore": "Lifetime Score",
  "profile.gamesPlayed": "Games Played",
  "profile.streakMilestones": "Streak Milestones",
  "profile.bestDays": "Best: {count} Days",
  "profile.badges": "Badges",
  "profile.joined": "Joined {date}",
  "profile.addToHome": "Add to Home Screen",
  "profile.shareProfile": "Share Profile",
  "profile.contactUs": "Contact Us",
  "profile.deleteAccount": "Delete Account",
  "profile.deleteAccountConfirm": "This will permanently delete your account, stats, and profile. Continue?",
  "profile.deleteAccountConfirm2": "Final confirmation: delete forever?",
  "profile.deleteAccountDone": "Account deleted.",
  "profile.deleteAccountFailed": "Deletion failed. Please try again or contact us.",
  "profile.linkCopied": "Link copied to clipboard!",
  "profile.days": "{count} days",
  "profile.badge.streaker": "Streaker",
  "profile.badge.quickRiff": "Quick Player",
  "profile.badge.champion": "Champion",
  "profile.badge.audiophile": "Audiophile",
  "profile.installIOS.safari": "Tap the Share button at the bottom of Safari, then select \"Add to Home Screen\"",
  "profile.installIOS.other": "To install, open this page in Safari, then tap Share → \"Add to Home Screen\"",
  "profile.continueAsGuest": "Continue as guest",

  // How to Play
  "howto.rules": "The Rules",
  "howto.title": "How To Play",
  "howto.subtitle": "Think you know your niggunim?\nOne note at a time.",
  "howto.step1Title": "Listen to one note",
  "howto.step1Desc": "We play one note from a niggun.\nCould be piano, guitar, or organ.\nLet's see what you've got.",
  "howto.step2Title": "Guess the niggun",
  "howto.step2Desc": "Type your guess.\nAutocomplete helps with spelling.\nNail it on note one — that's a shpitz.",
  "howto.step3Title": "Not sure? Keep going",
  "howto.step3Desc": "Tap MORE for another note.\nUp to 6 notes total.\nEach extra note costs points.",
  "howto.step4Title": "Scoring & sharing",
  "howto.step4Desc": "♪1 = 6 points (shpitz)\n♪6 = 1 point (nu, still counts)\n0 = no good…\n\nDone? Share your score.",
  "howto.scoring": "Scoring",
  "howto.miss": "Miss",
  "howto.gameModes": "Game Modes",
  "howto.dailyTitle": "Daily Challenge",
  "howto.dailyDesc": "Same niggun for everyone. One try per day.\nMissed it? Come back tomorrow.",
  "howto.endlessTitle": "Praktis Shpiel",
  "howto.endlessDesc": "Niggun after niggun, no limits.\nSee how long your streak holds.",
  "howto.playlistTitle": "Playlists",
  "howto.playlistDesc": "Pick a theme — Shabbos, Chassidish, Simcha, and more.\nPlay only niggunim from that list.",
  "howto.weeklyTitle": "Weekly Challenge",
  "howto.weeklyDesc": "A new set of niggunim every week.\nCompete for the top streak by Motzei Shabbos.",
  "howto.h2hTitle": "Head-to-Head",
  "howto.h2hDesc": "Invite a friend. Same niggunim, same notes. Whoever guesses faster wins.",
  "howto.boardTitle": "Leaderboard",
  "howto.boardDesc": "Weekly and all-time rankings. Coming soon!",

  // Install
  "install.streak": "{count}-day streak! Install Niggunim for quick access",
  "install.default": "You're on a roll! Install Niggunim for quick access",
  "install.button": "Install",

  // Notifications
  "notif.title": "Don't lose your streak",
  "notif.subtitle": "Get a reminder before it breaks",
  "notif.button": "Notify me",

  // Share landing
  "shareLanding.gotIt": "{name} got it in ♪{stage}!",
  "shareLanding.failed": "{name} couldn't get it today",
  "shareLanding.beatThat": "Can you beat that?",
  "shareLanding.challengeBack": "⚔️ Challenge Back",
  "shareLanding.playToday": "Play Today's Challenge",
  "shareLanding.howDoesItWork": "How does it work?",

  // Weekly
  "weekly.complete": "Weekly Challenge Complete!",
  "weekly.leaderboard": "Leaderboard",

  // Onboarding
  "onboarding.letsPlay": "Let's Play!",
  "onboarding.skipIntro": "Skip intro",
  "onboarding.tagline": "Can you name that tune?",

  // Legal
  "legal.privacyPolicy": "Privacy Policy",
  "legal.terms": "Terms",
  "legal.accessibility": "Accessibility",
};
